import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { PassFoodCardDialogService } from '@libs/shared/ui/dialogs/pass-food-card-dialog/pass-food-card-dialog.service';
import { PassFoodCardDialogComponent } from './pass-food-card-dialog.component';

@NgModule({
  declarations: [PassFoodCardDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  providers: [PassFoodCardDialogService],
})
export class PassFoodCardDialogModule {
  constructor(private _passFoodCardDialogService: PassFoodCardDialogService) {}
}
